import React, { Component, Fragment } from "react";
import Select from "react-select";
const Styles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "white",
      width: 80,
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: 14,
    }),
  };
const options = [
    {label:"AM",value:"am"},
    {label:"PM",value:"pm"}
]
class TimePicker extends Component {
  state = {
    option:{value:"am",label:"AM"},
    hh:"00",
    mm:"00"
  };
  handleSelectChange = (option) => {
    this.setState({ option },()=>{
        const {hh,mm} = this.state;
        const {onChange} = this.props;
        let obj={
            hh:parseInt(hh),
            mm:parseInt(mm),
            of:option.value,
        }
        onChange(obj);
    });
   
  }; 
  onChangeInput = e=>{
    this.setState({[e.target.name]:e.target.value},()=>{
        const {option,hh,mm} = this.state;
        const {onChange} = this.props;
        let obj={
            hh:parseInt(hh),
            mm:parseInt(mm),
            of:option.value,
        }
        onChange(obj);
    });
  }
  render() {
    const {option,hh,mm} = this.state;
    
    return (
      <div className="time-container" style={{width:230}}>
        <input className="form-control" 
            type="number" placeholder="HH" name="hh" max="12" min="0" onChange={this.onChangeInput} value={hh}/>
        &nbsp;:&nbsp;
        <input className="form-control" 
            type="number" placeholder="MM" name="mm" max="59" min="0" onChange={this.onChangeInput} value={mm}/>
        &nbsp;&nbsp;&nbsp;
        <Select 
            value={option}
            onChange={this.handleSelectChange}
            options={options}
            styles={Styles}
        />
      </div>
    );
  }
}

export default TimePicker;


// WEBPACK FOOTER //
// ./src/components/TimePicker.js